import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { Close } from '@mui/icons-material';
import StyledSessionDialogAppBarTitle from 'common/theme/session/dialog/StyledSessionDialogAppBarTitle';

function SessionCreateDialogAppBar({ children = null, onDialogClose }) {
  const { t } = useTranslation(['buttons']);

  return (
    <AppBar sx={{ position: 'relative' }} color="transparent">
      <Toolbar>
        {/* Título + toggle (Individual/Grupal) pegados a la izquierda; cerrar a la derecha. */}
        <StyledSessionDialogAppBarTitle variant="h2" sx={{ flexGrow: 0, mr: 2 }}>
          {t('session.create', { ns: 'buttons' })}
        </StyledSessionDialogAppBarTitle>
        {children}
        <Box sx={{ flexGrow: 1 }} />
        <IconButton
          edge="end"
          color="inherit"
          onClick={onDialogClose}
          aria-label={t('close', { ns: 'buttons' })}>
          <Close />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

SessionCreateDialogAppBar.propTypes = {
  children: PropTypes.node,
  onDialogClose: PropTypes.func.isRequired
};

export default SessionCreateDialogAppBar;
